<template>
  <div class="detail">
    <div class="detail-header">
      <img :src="styleColor?redSecBg:blueSecBg" class="coupon-detail-bg" />
      <div @click="viewNotes" class="tip">- 购卡须知 -</div>
      <div class="price f" v-if="cardInfo.maxAmount > 0">
        <div class="unit">￥</div>
        <div class="price-detail">{{cardInfo.maxAmount}}</div>
      </div>
      <div class="info">{{cardInfo.name}}</div>
      <div class="btn-box f fvc">
        <div class="btn-content">购卡最多可省{{cardInfo.maxAmount}}元</div>
      </div>
    </div>
    <div class="detail-body">
      <coupon-item
        v-for="item in couponList"
        :source="'couponDetail'"
        :item="item"
        :key="item.id"
        :tradeNo="cardInfo.tradeNo"
        :buy="buy"
        :stylecolor="styleColor"
      ></coupon-item>
    </div>
    <div class="detail-footer f fc frd">
      <div class="f v fvc">
        <img src="https://j.weizan.cn/youxiang/back-pic.png" class="back-pic" />
        <div class="back-tip" @click="backHome">返回首页</div>
      </div>
      <div
        class="buy-btn"
        @click="toast"
        v-if="actStatus==='finish'"
        :class="{'red-bgc':styleColor}"
      >活动已结束</div>
      <div
        class="buy-btn"
        @click="buyCard"
        v-else-if="!buy"
        :class="{'red-bgc':styleColor}"
      >支付{{cardInfo.seckillPrice}}元购卡</div>
      <div class="buy-btn" @click="useCard" :class="{'red-bgc':styleColor}" v-else>立即使用</div>
    </div>
    <div v-if="signupFlag">
      <act-signup
        :enrollNum="enrollNum"
        :callSrouce="'card_signup'"
        @closeSignup="closeSignup"
        @signupSuccess="signupSuccess"
        @buyNow="confirmBuy"
      ></act-signup>
    </div>
  </div>
</template>

<script>
import CouponItem from "./../../components/coupon-item";
import ActSignup from "./../../components/act-signup";
import { mapState } from "vuex";
export default {
  components: {
    CouponItem,
    ActSignup,
  },
  data() {
    return {
      cardInfo: {},
      couponList: [],
      signupFlag: false,
      buy: false,
      actStatus: "",
      enrollStatus: localStorage.getItem("setEnrollStatus"),
      styleColor: true, //页面风格默认红色
      redSecBg:
        "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/image/common/style/red/coupon.png", //页面风格默认红色
      blueSecBg: "https://j.weizan.cn/youxiang/coupon-detail-bg.png?v=4", //蓝色卡券bg
    };
  },
  computed: {
    // ...mapState(["enrollStatus"]),
  },
  created() {
    this.$initWXSDK(
      {
        openShare: true,
      },
      () => {
        this.$utils.getLocation().then((res) => {});
      }
    );
    this.$store.commit("setLoading", true);
    this.getCardInfo();
    this.getActInfo();
  },
  methods: {
    toast() {
      this.$toast("活动已结束，感谢你的支持~");
    },
    closeSignup() {
      this.signupFlag = false;
    },
    useCard() {
      this.$router.push({
        path: "/my/myCoupon",
        act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      });
    },
    signupSuccess() {
      // this.$store.commit("setEnrollStatus", "enrolled");
      localStorage.setItem("setEnrollStatus", "enrolled");
      this.enrollStatus = "enrolled";
      this.closeSignup();
    },
    buyCard() {
      this.$utils.checkEnroll().then(() => {
        this.$txLogs({
          bpm: "3.card_pay",
        });
        if (this.enrollStatus !== "enrolled") {
          this.signupFlag = true;
          return false;
        }
        this.confirmBuy();
      });
    },
    confirmBuy() {
      this.$txLogs({
        bpm: "3.card_submit",
      });
      var self = this;
      this.$http
        .post("/v1/pay/create_order", {
          orderType: "card",
          cardId: this.cardInfo.id,
        })
        .then((result) => {
          console.log(result);
          if (result.data && result.code == 0) {
            let tmp = {
              appId: result.data.appId, //公众号名称，由商户传入
              timeStamp: result.data.timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: result.data.nonceStr, //随机串
              package: result.data.packageValue,
              signType: result.data.signType, //微信签名方式：
              paySign: result.data.paySign, //微信签名
            };
            self.wechatPay(tmp);
          } else if (result.code == 20706) {
            that.$toast(result.msg);
            // 充值成功后，跳转到首页
            // let tmp = localStorage.getItem("preheatPath") || "preheat";
            // self.$router.push({
            //   path: tmp,
            //   act_id: localStorage.getItem("act_id"),
            // });
            window.location.reload();
          }
        });
    },

    wechatPay(json) {
      const that = this;
      try {
        if (typeof WeixinJSBridge !== "undefined") {
          WeixinJSBridge.invoke("getBrandWCPayRequest", json, (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              that.$toast("支付成功！");
              that.getCardInfo();
            }
          });
        } else {
          that.$toast("请使用微信支付");
        }
      } catch (e) {
        that.$toast("服务器繁忙，请稍后再试");
      }
    },
    async getCardInfo() {
      let info = await this.$http.post("/v1/seckill/card/list", {});
      this.$store.commit("setLoading", false);

      if (info.code === 0) {
        this.actStatus = info.data.actStatus;
        this.buy = info.data.buy;
        this.cardInfo = info.data.card;
        this.couponList = info.data.couponList;
        console.log(this.couponList);
      }
    },
    viewNotes() {
      const that = this;
      that.$dialog({
        title: "购券须知",
        message: this.cardInfo.prompt,
      });
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    getActInfo() {
      this.$http.post("/v1/home/activity").then((res) => {
        if (res.code === 0) {
          this.styleColor = res.data.style == "red" ? true : false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.red-bgc {
  background: #b80000 !important;
}
.red-bgc-light {
  background: rgba(184, 0, 0, 0.6) !important;
}
.red-c {
  color: #b80000 !important;
}
.white-c {
  color: #ffffff !important;
}
.red-linear {
  background: linear-gradient(90deg, #9b0000, #b80000, #9b0000) !important;
}
.red-boxs {
  box-shadow: 0px 10px 11px 0px rgba(184, 0, 0, 0.68) !important;
}
.detail {
  padding-bottom: 70px;
  .detail-header {
    position: relative;
    top: -1px;
    .tip {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(245, 211, 170, 1);
      text-align: center;
      position: absolute;
      top: 180px;
      width: 100%;
    }
    .coupon-detail-bg {
      width: 100%;
    }
    .price {
      font-size: 24px;
      font-family: DIN;
      font-weight: bold;
      color: rgba(141, 81, 22, 1);
      position: absolute;
      right: 43px;
      top: 47px;
      .unit {
        font-size: 15px;
        position: relative;
        top: 8px;
      }
    }
    .btn-box {
      width: 100%;
      position: absolute;
      top: 134px;
      font-size: 15px;
    }
    .btn-content {
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 50, 55, 1);
      text-align: center;
      height: 30px;
      line-height: 30px;
      background: linear-gradient(
        90deg,
        rgba(230, 169, 108, 1),
        rgba(245, 211, 170, 1)
      );
      border-radius: 15px;
      padding: 0 27px;
    }
    .info {
      width: 100%;
      text-align: center;

      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 241, 221, 1);
      position: absolute;
      top: 94px;
    }
  }
  .detail-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    background: #fff;
  }
  .back-pic {
    width: 22px;
    height: 22px;
    margin-bottom: 7px;
  }
  .back-tip {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
  .buy-btn {
    width: 280px;
    height: 44px;
    background: rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 44px;
    text-align: center;
  }
}
</style>